//add, move, edit, view, time, link

export const actionTypeToEmojis: {[key: string]: string} = {
    add: '✅',
    move: '↔️',
    edit: '✏️',
    view: '🔍',
    time: '🕐',
    link: '🔗'
}